export interface ApiProblem {
  type: string; title: string; status: number;
  detail?: string; instance?: string; code?: string;
}
export async function parseProblem(err: unknown): Promise<ApiProblem | null> {
  const resp = (err as { response?: { status: number; json: () => Promise<unknown> } }).response;
  if (!resp || typeof resp.json !== 'function') return null;
  try {
    const body = (await resp.json()) as Partial<ApiProblem>;
    if (!body || typeof body.title !== 'string') return null;
    return {
      type: body.type ?? 'about:blank',
      title: body.title,
      status: body.status ?? resp.status,
      detail: body.detail,
      instance: body.instance,
      code: body.code,
    };
  } catch { return null; }
}
